var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showComponent,
          expression: "showComponent",
        },
      ],
    },
    [
      _c("select2", {
        ref: "select",
        staticClass: "applicant-select-simple",
        class: _vm.className,
        attrs: {
          id: _vm.id,
          data: _vm.excludingApplicants,
          value: _vm.selectedApplicantIndexes,
          name: "applicant-select",
          options: _vm.select2Options,
          "format-data": _vm.formatData,
          multiple: _vm.multiple ? "inline" : null,
          disabled: _vm.disabled,
        },
        on: { change: _vm.handleChange },
      }),
      _vm._v(" "),
      _c("label", { staticClass: "d-none", attrs: { for: _vm.id } }, [
        _vm._v("\n    " + _vm._s(_vm.$t("documents.selectApplicant")) + "\n  "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }